import { Component, OnInit } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterLink } from '@angular/router';

@Component({
    selector: 'app-key-concepts',
    imports: [ MatToolbarModule, MatDividerModule, MatIconModule, RouterLink],
    templateUrl: './key-concepts.component.html',
    styleUrls: ['./key-concepts.component.scss'],
})
export class KeyConceptsComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  back() {
    this.router.navigate(['home']);
  }

}
